import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { InventoryService } from 'src/app/_services/inventory.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { forkJoin, of } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
@Component({
    selector: 'app-add-via-serial-number-sku',
    templateUrl: './add-via-serial-number-sku.component.html',
    styleUrls: ['./add-via-serial-number-sku.component.scss'],
    standalone: false
})
export class AddViaSerialNumberSkuComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;
  transferType: any;
   addNumberForm : UntypedFormGroup;
  submitTouched: boolean = false;
  maxEntriesError: boolean = false; // <-- NEW: track if max entries exceeded
  serialSkuNumber: any;

  constructor(
    public modalRef : BsModalRef,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private inventoryService: InventoryService
  ) { 
    super();
     this.addNumberForm = new UntypedFormGroup({
            'serialSkuNumber': new UntypedFormControl(null, [Validators.required]),
         });
  }

  ngOnInit(): void {
    console.log(this.data)
    this.transferType = this.data.transferType;
   this.translate = this.data.translate;
    // Subscribe to form value changes to validate on the fly
    this.addNumberForm.get('serialSkuNumber')?.valueChanges.subscribe(value => {
      this.validateSerialSkuInput(value);
    });
        
  }
  private parseEntries(raw: any): any[] {
  if (!raw) return [];
  return raw
    .split(/\r?\n|,/)     // <-- split on newline, comma (plit on newline, comma, semicolon, tab .split(/\r?\n|,|;|\t/) )
    .map(s => s.trim())
    .filter(Boolean);
}

  // NEW: Validation logic to limit maximum 50 serial/SKU numbers
  validateSerialSkuInput(value: string) {
    if (!value) {
      this.maxEntriesError = false;
      return;
    }
    const entries = this.parseEntries(value);
    

    if (entries.length > 50) {
      this.maxEntriesError = true;

      // Optional: Auto-trim to first 50 entries
      const trimmedEntries = entries.slice(0, 50);
      this.addNumberForm.get('serialSkuNumber')?.setValue(trimmedEntries.join(', '), { emitEvent: false });

      // Note: emitEvent:false prevents infinite loop
    } else {
      this.maxEntriesError = false;
    }
  }

  
  push(obs: any) {
    super.push(obs);
  }
  submitAddNumberForm() {
   

    if (this.addNumberForm.valid) {
      // Handle valid form submission
      console.log('Form Submitted:', this.addNumberForm.value);
      
    }

         const raw = this.addNumberForm.value.serialSkuNumber as string;
        let entries: string[] = this.parseEntries(raw);
        // if numeric SKUs
        const productSkus = entries.map(e => e.replace(/\s+/g, ''));

         console.log(productSkus.length,"====",entries)
         
         if(productSkus.length > 50){
           this.errorUtil.setErrorMessage(this.translate?.binTransfer.messages.maxSerialSkuLimitExceeded);
           return;
         }
        
         this.spinner.show()
    if(this.transferType === 'asset'){
   var modifiedData ={
          serialNumbers: entries,
        }
      this.inventoryService.getAssetByAssetIdTransferFromAsset(modifiedData).subscribe((res:any) => {
        console.log(">>>>>>>>>>>>>")
        this.spinner.hide()
        if(res.length === 0){
          this.errorUtil.setErrorMessage(400,null,"No Asset was found with this serial number", "error", 3000);
        }else{
           this.inventoryService.setItems(res);
           this.modalRef.hide();
        }
      })
    }else{

       var data ={
          productSkus: entries,
        }
      
      this.inventoryService.getAssetByAssetIdTransferFromSparePart(data).subscribe((res: any[]) => {
  // early exit
  if (!Array.isArray(res) || res.length === 0) {
    this.spinner.hide();
    this.errorUtil.setErrorMessage(400, null, "No Spare Part was found with this serial number", "error", 3000);
    return;
  }

  // build one forkJoin per element (for its types), then wait for all elements
  const perElement$ = res.map(element => {
    const types: string[] = Array.isArray(element.types) ? element.types : [];
    const calls = types.map(t => {
      const locationType = t === 'USER' ? 'user' : 'location';
      return this.inventoryService
        .getFromBinByProduct(locationType, element.product.id)
        .pipe(catchError(() => of([]))); // don't fail the whole batch on one error
    });

    // if no types, still return element with empty lists
    const join$ = calls.length ? forkJoin(calls) : of([[]]);

    return join$.pipe(
      map((results: any[][]) => {
       const mergedBins = dedupeById([].concat(...results)); // merge USER+LOCATION results
        return {
          ...element,
          binlist: mergedBins,
          backupBinList: [...mergedBins],
        };
      })
    );
  });

  forkJoin(perElement$)
    .pipe(finalize(() => this.spinner.hide()))
    .subscribe({
      next: (listOfBins: any[]) => {
        this.inventoryService.setItems(listOfBins); // <-- fires AFTER all bin lookups completed
        this.modalRef.hide();
      },
      error: (err) => {
        this.errorUtil.setErrorMessage(500, null, 'Failed to load bins', 'error', 3000);
      }
    });
});
    }
  }
}
// helper: dedupe bins by id
const dedupeById = <T extends { id?: any }>(arr: T[]) => {
  const seen = new Set<any>();
  return arr.filter(x => {
    const id = x?.id;
    if (id == null || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};
